export default __webpack_public_path__ + "static/trackthebat6-63747cfc535d16612f8adb33c2ff63ab.png";